import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'

import { ROUTES } from '../utils/constants/enum'
import { conditionalClasses } from '../utils/helper-functions'
import { removeHubspotScripts } from '../utils/helper-functions'

import { Button } from '@mui/material'
import logo from '../assets/images/logo/hydrafacial.svg'
import { Axios } from '../services/axios'
import './header.scss'
import { useHubspot } from '../providers/contexts/HubspotContext'

const SignOut = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { disableHubspot } = useHubspot()
    const location = useLocation()

    const signOutClick = async () => {
        // First disable Hubspot and wait for cleanup
        await new Promise<void>((resolve) => {
            disableHubspot()
            // Give time for Hubspot cleanup
            setTimeout(resolve, 100)
        })
        // Then handle other cleanup
        await Promise.all([
            Axios.destroySyndeoInstance(),
            Axios.destroyMiddleLayerInstance(),
        ])

        // Force a reload instead of navigation to ensure complete cleanup
        window.location.href = ROUTES.ACCOUNTS
    }

    return (
        <ul>
            <li>
                <Button onClick={signOutClick} className="signout">
                    {t('common_elements.sign_out_button_text')}
                </Button>
            </li>
        </ul>
    )
}

const AccountHeader = (props: any) => {
    const { status } = props
    const navigate = useNavigate()
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false)

    const onLogoClick = () => {
        setMobileMenuOpen(false)
        navigate('/')
    }

    useEffect(() => {
        const bodyEl = document.getElementsByTagName('body')[0]
        if (isMobileMenuOpen) {
            bodyEl.classList.add('menu-open')
        } else {
            bodyEl.classList.remove('menu-open')
        }
    }, [isMobileMenuOpen])

    return (
        <header>
            <nav
                className={conditionalClasses(
                    !status,
                    'justify-center',
                    '',
                    'account-header'
                )}
            >
                <div className="left-panel">
                    <div className="header-logo">
                        <Button onClick={onLogoClick}>
                            <img
                                src={logo}
                                alt="Hydrafacial Logo"
                                className="logo syndeo-logo"
                            />
                        </Button>
                        <div className="hide-tablet-mobile">Accounts</div>
                    </div>
                    {status && (
                        <button
                            className={conditionalClasses(
                                isMobileMenuOpen,
                                'opened',
                                '',
                                'menu hide-desktop'
                            )}
                            aria-label="Main Menu"
                            onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                        >
                            <svg width="32" height="32" viewBox="0 0 100 100">
                                <path
                                    className="line line1"
                                    d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
                                />
                                <path className="line line2" d="M 20,47 H 80" />
                                <path
                                    className="line line3"
                                    d="M 20,66.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
                                />
                            </svg>
                        </button>
                    )}
                </div>
                {status && (
                    <div className="right-nav hide-tablet-mobile">
                        <SignOut />
                    </div>
                )}
            </nav>
            {status && (
                <nav
                    className={conditionalClasses(
                        isMobileMenuOpen,
                        'opened',
                        '',
                        'mobile-nav hide-desktop'
                    )}
                >
                    <SignOut />
                </nav>
            )}
        </header>
    )
}

export default AccountHeader
